angular.module('app').config(systemMaintenanceRouting);

function systemMaintenanceRouting($routeProvider) {
  $routeProvider.when('/system_maintenance', {
    pageTitle: 'SYSTEM_MAINTENANCE',
    template: '<system-maintenance-page></system-maintenance-page>',
    accessPermission: [
      'update_countries_for_master_db_systemmaintenance_superadmin',
      'update_countries_for_all_accounts_systemmaintenance_superadmin',
      'update_countries_for_one_account_systemmaintenance_superadmin',
      'update_account_admin_roles_actions_for_all_accounts_systemmaintenance_superadmin',
      'update_roles_actions_for_one_account_systemmaintenance_superadmin',
      'delete_roles_actions_not_found_in_permissions_for_all_accounts_systemmaintenance_superadmin',
    ],
    authReq: true,
  });
}

systemMaintenanceRouting.$inject = ['$routeProvider'];
